import { memo } from 'react';

import { ModelPanel } from '@/components/flow';

import { SlideOut } from './SlideOut.tsx';

export type ModelPanelProps = {
  agentId: string;
  modelId: string;
};

const IModelPanelSlideOut = ({ agentId, modelId }: ModelPanelProps) => {
  return (
    <SlideOut>
      <ModelPanel agentId={agentId} modelId={modelId} />
    </SlideOut>
  );
};

export const ModelPanelSlideOut = memo(IModelPanelSlideOut) as typeof IModelPanelSlideOut;
